import { QRCodeSVG } from 'qrcode.react';
import { usePaymentRegistrationContext } from '@context/Payment/PaymentRegistration';
import FocusableIconButton from '@components/FocusableIconButton';
import { REGISTRATION_COMPLETION } from '../../../focuskey';
import * as styles from './styles';

const Content = () => {
  const { targetUrl, paymentMethods, checkRegistered } = usePaymentRegistrationContext();
  return (
    <div>
      <p css={styles.title}>결제 수단을 등록해주세요</p>
      <div css={styles.content}>
        <QRCodeSVG css={styles.qrCode} value={targetUrl} />
        <div css={styles.instruction}>
          <p css={styles.commonInformation}>
            모바일에서 QR코드를 스캔해 웹페이지에 접속하고 <br />
            결제수단 등록을 진행해주세요.
          </p>
          <p css={styles.descriptionInformation}>
            진료가 끝난 후 결제가 진행되고, 결제 정보는 안전하게 보관돼요.
          </p>
          {paymentMethods.length === 0 && (
            <p css={styles.noPaymentText}>아직 등록된 결제수단이 없습니다.</p>
          )}
          <div css={styles.button}>
            <FocusableIconButton
              focusKey={REGISTRATION_COMPLETION}
              onEnterPress={checkRegistered}
              iconType={'arrow'}
            >
              등록 완료
            </FocusableIconButton>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Content;
